import { PaymentMethod, SelectablePaymentMethod } from "../../../common/payment";

export const getSelectablePaymentMethod = (paymentMethods: PaymentMethod[] | null, token: string) =>
    (paymentMethods?.find((p) => "token" in p && p.token === token) as SelectablePaymentMethod | undefined) ?? null;
